/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Create_Choose_Type_Person_DescriptionInputs */

const en_clients_create_choose_type_person_description = /** @type {(inputs: Clients_Create_Choose_Type_Person_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Register an individual client using a CPF.`)
};

const pt_br2_clients_create_choose_type_person_description = /** @type {(inputs: Clients_Create_Choose_Type_Person_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cadastre um cliente pessoa física utilizando o CPF.`)
};

/**
* | output |
* | --- |
* | "Register an individual client using a CPF." |
*
* @param {Clients_Create_Choose_Type_Person_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_create_choose_type_person_description = /** @type {((inputs?: Clients_Create_Choose_Type_Person_DescriptionInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Create_Choose_Type_Person_DescriptionInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_create_choose_type_person_description(inputs)
	return pt_br2_clients_create_choose_type_person_description(inputs)
});